module.exports = __webpack_public_path__ + "static/media/logo_cabezofp.000fd88e.jpg";